export const hosturl = "https://api.zodeals.in";
// export const hosturl = "http://10.196.124.161:6006";
